import { connect } from 'react-redux';
import { updateFavourite } from '@noths/polaris-client-user-favourites';
import getConfig from 'next/config';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  elevaateProductImpressions,
  loadPageOfProducts,
  UpdateHistoryPayload,
  updatePageHistory,
} from 'src/redux/products';
import {
  selectCurrentPage,
  selectLoadingStateForPage,
  selectProductsForPage,
  selectProductsReturnedCount,
  selectTotalPages,
  selectTotalProducts,
} from 'src/redux/selectors';
import { AppThunkDispatch } from 'src/redux/store';
import { NextConfig, Product, ProductUrlType } from 'src/types';
import { ProductPage } from '../components/ProductPage';
import { onProductClick } from '../modules/actions';
import {
  selectIsFirstDisplayedPage,
  selectIsLastDisplayedPage,
  selectLoadMoreProductsURL,
  selectLoadPreviousProductsURL,
  selectNumberOfProductsViewed,
  selectProductPaginationProgress,
  selectReferredBy,
} from '../modules/selectors';
import { ProductPageContainerProps } from '../types';

type ProductCode = Product['code'];

const nextConfig = getConfig() as NextConfig;

export const mapStateToProps = (
  state: ReduxApplicationState,
  ownProps: ProductPageContainerProps,
) => ({
  products: selectProductsForPage(state, ownProps),
  totalPages: selectTotalPages(state),
  currentPage: selectCurrentPage(state),
  totalNumberOfProducts: selectTotalProducts(state),
  numberOfProductsDisplayed: selectProductsReturnedCount(state),
  isLoading: state.products.isLoading,
  isClientRequest: state.products.isClientRequest,
  progress: selectProductPaginationProgress(state, ownProps),
  numberOfProductsViewed: selectNumberOfProductsViewed(state, ownProps),
  isPageLoading: selectLoadingStateForPage(state, ownProps),
  isFirstDisplayedPage: selectIsFirstDisplayedPage(state, ownProps),
  isLastDisplayedPage: selectIsLastDisplayedPage(state, ownProps),
  loadMoreURL: selectLoadMoreProductsURL(state),
  loadPreviousURL: selectLoadPreviousProductsURL(state),
  referredBy: selectReferredBy(state),
});

export const mapDispatchToProps = (
  dispatch: AppThunkDispatch,
  { page }: ProductPageContainerProps,
) => ({
  updateFavourite: (productCode: ProductCode) =>
    dispatch(updateFavourite({ productCode, nextConfig })),
  updatePageHistory: (payload: UpdateHistoryPayload) => dispatch(updatePageHistory(payload)),
  onLoadMore: () => dispatch(loadPageOfProducts(page + 1)),
  onLoadPrevious: () => dispatch(loadPageOfProducts(page - 1)),
  onProductClick: (
    productUrl: ProductUrlType,
    destinationUrl: ProductUrlType,
    productCode: ProductCode,
  ) => {
    dispatch(onProductClick({ productUrl, destinationUrl, productCode }));
  },
  elevaateProductImpressions: (products: Product[]) =>
    dispatch(elevaateProductImpressions({ products })),
});

export const ProductPageContainer = connect(mapStateToProps, mapDispatchToProps)(ProductPage);
